import { ButtonProps } from 'antd/lib/button';

import { UiButton } from '../ui-button';

type Props = {
  disabled?: boolean;
} & ButtonProps;

export function UiSubmitButton(props: Props) {
  const disabled = Boolean(props.disabled);

  return (
    <UiButton {...props} htmlType="submit" type="primary" disabled={disabled}>
      Сохранить
    </UiButton>
  );
}
